import React, { useState, useEffect } from 'react';
import TransactionFilters from '../components/TransactionFilters';
import GroupStationsSummary from '../components/GroupStationsSummary';
import { toast } from 'react-hot-toast';
import dayjs from 'dayjs';
import useUpdateChargingStationDetails from '../hooks/useUpdateChargingStationDetails';

const ChargingStations = () => {
  // const { stations, isLoading, error, message } = useUpdateChargingStationDetails();
  const [localStations, setLocalStations] = useState([]);

  // Filters
  const [filters, setFilters] = useState({
    search: '',
    status: 'all'
  });

  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({ ...prev, [filterName]: value }));
  };

  const handleClearFilters = () => {
    setFilters({ search: '', status: 'all' });
  };

  // Apply filters
  const filteredStations = localStations.filter(station => {
    if (filters.search && !station.station_name.toLowerCase().includes(filters.search.toLowerCase())) return false;
    if (filters.status !== 'all' && station.status !== filters.status) return false;
    return true;
  });

  return (
    <div className="mx-auto max-w-[1600px] pb-10">
      <GroupStationsSummary />
    </div>
  );
};

export default ChargingStations;
